import { searchFilterKeysMap } from '@rover/shared/js/search/utilities/searchFiltersMap';
import { SearchFilters } from '@rover/types';
import { DateRange } from '@rover/types/src/datetime/DateRange';

/**
 * @description Takes in the coordinates passed in and determines what params to set
 * @param searchParams
 * @param cleanedFilters
 */
export const validateAndSetSearchBounds = (
  searchParams: URLSearchParams,
  cleanedFilters: Partial<SearchFilters & { dateRange: DateRange }>
): void => {
  const { minlat, minlng, maxlat, maxlng, centerlat, centerlng } = cleanedFilters;

  const coords = { minlat, maxlat, minlng, maxlng };
  const boundsHaveValue = [minlat, maxlat, minlng, maxlng].every((value) => value !== undefined);
  const boundsMissingValue = !boundsHaveValue;
  const latOrLngEqual = minlat === maxlat || minlng === maxlng;
  const centerlatAndLngExist = centerlat && centerlng;
  const shouldAddSearchBounds = !(boundsMissingValue || (boundsHaveValue && latOrLngEqual));
  if (shouldAddSearchBounds) {
    Object.keys(coords).forEach((key) => {
      if (coords[key] !== undefined) {
        searchParams.set(searchFilterKeysMap[key], coords[key].toString());
      }
    });
  }
  if (centerlatAndLngExist) {
    searchParams.set(searchFilterKeysMap.centerlat, centerlat.toString());
    searchParams.set(searchFilterKeysMap.centerlng, centerlng.toString());
  }
};
